import { Component, ViewChild, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { CameraService } from '../../../providers/scan-service/camera.service';
import { CameraPreviewOptions } from '@ionic-native/camera-preview/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-share-photo',
  templateUrl: './share-photo.page.html',
  styleUrls: ['./share-photo.page.scss']
})
export class SharePhotoPage implements OnInit, OnDestroy {
  @ViewChild('canvasElement', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('imgOverlay', { static: true }) img: ElementRef<HTMLImageElement>;
  @ViewChild('top', { static: true }) top: ElementRef<HTMLElement>;
  @ViewChild('header', { static: true, read: ElementRef }) header: ElementRef<HTMLElement>;

  subscriptions: Subscription[] = [];

  canvasShare: HTMLCanvasElement;
  imageSrcData: string;
  width = window.innerWidth;
  heightDiv = 0;
  overlayImgUrl: string;

  constructor (
    private cameraService: CameraService,
    private socialSharing: SocialSharing,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  cameraPreviewOpts: CameraPreviewOptions = {
    x: 0,
    y: 0,
    width: window.screen.width,
    height: window.screen.height,
    camera: 'front',
    tapPhoto: true,
    previewDrag: true,
    toBack: true,
    alpha: 1
  }

  ngOnInit () {
    this.cameraService.cameraPreview.startCamera(this.cameraPreviewOpts).then();
    this.subscriptions.push(this.route.queryParams.subscribe((qp: Params) => {
      this.overlayImgUrl = decodeURIComponent(qp.overlayImg);
      this.img.nativeElement.crossOrigin = 'anonymous';
    }));
  }

  ngOnDestroy (): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  take () {
    this.cameraService.cameraPreview.takeSnapshot().then((base64PictureData) => {
      this.imageSrcData = 'data:image/jpeg;base64,' + base64PictureData;
      const headerHeight = this.header.nativeElement.offsetHeight;
      const topDraw = this.top.nativeElement.offsetHeight + headerHeight;
      const image = new Image();
      const imageShare = new Image();
      const sizeShare = 3;
      this.canvas.nativeElement.width = this.width;
      this.canvas.nativeElement.height = this.width;
      this.canvasShare = document.createElement('canvas');
      this.canvasShare.width = this.width * sizeShare;
      this.canvasShare.height = this.width * sizeShare;
      const overlay = this.img.nativeElement;
      const ctx: CanvasRenderingContext2D = this.canvas.nativeElement.getContext('2d');
      const ctxShare: CanvasRenderingContext2D = this.canvasShare.getContext('2d');
      image.onload = () => {
        ctx.drawImage(image, 0, -1 * topDraw, this.width, window.screen.height);
        ctx.drawImage(overlay, 0, 0, this.width, this.width);
      };
      imageShare.onload = () => {
        ctxShare.drawImage(imageShare, 0, -1 * topDraw * sizeShare, this.width * sizeShare, window.screen.height * sizeShare);
        ctxShare.drawImage(overlay, 0, 0, this.width * sizeShare, this.width * sizeShare);
      };
      image.width = this.width;
      image.src = this.imageSrcData;
      imageShare.width = this.width * sizeShare;
      imageShare.src = this.imageSrcData;
    }).catch(() => {
      console.error('Error share-photo');
    });
  }

  reset () {
    this.imageSrcData = null;
  }

  share () {
    const dataURL = this.canvasShare.toDataURL();
    this.socialSharing.share(null, 'arianee-wallet', dataURL);
  }

  changeCamera () {
    this.cameraService.cameraPreview.switchCamera().then();
  }

  onClickNavBack () {
    this.location.back();
  }
}
